import React, { useContext } from 'react';
import PropTypes from 'prop-types';


import SubNavigation from "./SubNavigation";
import AuthorizedUser from "../utils/AuthorizedUser";
import AuthorizedUserContext from "../utils/AuthorizedUserContext";

function TrendsTabs(props) {
	const authenticatedUser = useContext(AuthorizedUserContext);

	let {tabClicked, selectedTab, setBannerClassName, hasNudgeBanner} = props;

	const tabs = [{
		label: "Trending Topics",
		value: "topics",
		hasAccess: true
	}];

	return (
		<SubNavigation
			tabs={tabs}
			title="Trends"
			selectFieldId="sentimentbutton"
			selectedTab={selectedTab}
			tabClicked={tabClicked}
			hasNudgeBanner={hasNudgeBanner}
			setBannerClassName={setBannerClassName} />
	);
}

TrendsTabs.propTypes = {
	hasNudgeBanner: PropTypes.bool,
	tabClicked: PropTypes.func.isRequired,
	setBannerClassName: PropTypes.func.isRequired,
	selectedTab: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired
};

export default TrendsTabs;